import React, { PureComponent } from 'react';
import Script from 'react-load-script';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import './WistiaEmbed.module.css';

const WistiaEmbed = DisplayComponent(
  class WistiaEmbed extends PureComponent {
    wistiaVideo = () => {
      const { videoId, classes } = this.props;
      return (
        <div styleName="responsive-video" className={classes}>
          <iframe
            title={`wistia embed ${videoId}`}
            src={`//fast.wistia.net/embed/iframe/${videoId}`}
            allowtransparency="true"
            frameBorder="0"
            scrolling="no"
            className="wistia_embed"
            name="wistia_embed"
            allowFullScreen
            mozallowfullscreen="true"
            webkitallowfullscreen="true"
            oallowfullscreen="true"
            msallowfullscreen="true"
          />
          <Script url="//fast.wistia.net/assets/external/E-v1.js" />
        </div>
      );
    };
    wistiaChannel = () => {
      const { videoId } = this.props;
      return (
        <div>
          <div
            className={`wistia_channel wistia_async_${videoId} mode=inline customFont=proxima-nova`}
          />
          <Script url="//fast.wistia.net/assets/external/channel.js" />
        </div>
      );
    };
    render() {
      const { videoType } = this.props;
      switch (videoType) {
        case 'video':
          return this.wistiaVideo();
        case 'channel':
          return this.wistiaChannel();
        default:
          return this.wistiaVideo();
      }
    }
  }
);

export default WistiaEmbed;
